/* tslint:disable */
/* eslint-disable */
/**
 * Commerce API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Address } from './Address';
import {
    AddressFromJSON,
    AddressFromJSONTyped,
    AddressToJSON,
} from './Address';
import type { LineItemReturnModel } from './LineItemReturnModel';
import {
    LineItemReturnModelFromJSON,
    LineItemReturnModelFromJSONTyped,
    LineItemReturnModelToJSON,
} from './LineItemReturnModel';
import type { Money } from './Money';
import {
    MoneyFromJSON,
    MoneyFromJSONTyped,
    MoneyToJSON,
} from './Money';
import type { PaymentReturnModel } from './PaymentReturnModel';
import {
    PaymentReturnModelFromJSON,
    PaymentReturnModelFromJSONTyped,
    PaymentReturnModelToJSON,
} from './PaymentReturnModel';
import type { PaymentTerms } from './PaymentTerms';
import {
    PaymentTermsFromJSON,
    PaymentTermsFromJSONTyped,
    PaymentTermsToJSON,
} from './PaymentTerms';
import type { ShipmentReturnModel } from './ShipmentReturnModel';
import {
    ShipmentReturnModelFromJSON,
    ShipmentReturnModelFromJSONTyped,
    ShipmentReturnModelToJSON,
} from './ShipmentReturnModel';

/**
 * 
 * @export
 * @interface BasketReturnModel
 */
export interface BasketReturnModel {
    /**
     * 
     * @type {string}
     * @memberof BasketReturnModel
     */
    basketId?: string;
    /**
     * 
     * @type {string}
     * @memberof BasketReturnModel
     */
    marketId?: string;
    /**
     * 
     * @type {Array<LineItemReturnModel>}
     * @memberof BasketReturnModel
     */
    lines?: Array<LineItemReturnModel>;
    /**
     * 
     * @type {Address}
     * @memberof BasketReturnModel
     */
    billingAddress?: Address;
    /**
     * 
     * @type {Address}
     * @memberof BasketReturnModel
     */
    shippingAddress?: Address;
    /**
     * 
     * @type {boolean}
     * @memberof BasketReturnModel
     */
    readonly useBillingAddressForShipping?: boolean;
    /**
     * 
     * @type {string}
     * @memberof BasketReturnModel
     */
    readonly note?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BasketReturnModel
     */
    readonly acceptNewsletter?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BasketReturnModel
     */
    readonly acceptTerms?: boolean;
    /**
     * 
     * @type {Money}
     * @memberof BasketReturnModel
     */
    subtotal?: Money;
    /**
     * 
     * @type {Money}
     * @memberof BasketReturnModel
     */
    total?: Money;
    /**
     * 
     * @type {Money}
     * @memberof BasketReturnModel
     */
    shippingTotal?: Money;
    /**
     * 
     * @type {Money}
     * @memberof BasketReturnModel
     */
    totalVat?: Money;
    /**
     * 
     * @type {Money}
     * @memberof BasketReturnModel
     */
    shippingVat?: Money;
    /**
     * 
     * @type {Money}
     * @memberof BasketReturnModel
     */
    totalDiscount?: Money;
    /**
     * 
     * @type {Money}
     * @memberof BasketReturnModel
     */
    remainingTotal?: Money;
    /**
     * 
     * @type {Money}
     * @memberof BasketReturnModel
     */
    paidTotal?: Money;
    /**
     * 
     * @type {Money}
     * @memberof BasketReturnModel
     */
    estimatedShippingCost?: Money;
    /**
     * 
     * @type {string}
     * @memberof BasketReturnModel
     */
    currency?: string;
    /**
     * 
     * @type {number}
     * @memberof BasketReturnModel
     */
    readonly quantity?: number;
    /**
     * 
     * @type {PaymentTerms}
     * @memberof BasketReturnModel
     */
    paymentTerms?: PaymentTerms;
    /**
     * 
     * @type {Array<string>}
     * @memberof BasketReturnModel
     */
    readonly promoCodes?: Array<string>;
    /**
     * 
     * @type {Date}
     * @memberof BasketReturnModel
     */
    readonly created?: Date;
    /**
     * 
     * @type {Date}
     * @memberof BasketReturnModel
     */
    readonly updated?: Date;
    /**
     * 
     * @type {string}
     * @memberof BasketReturnModel
     */
    orderState?: string;
    /**
     * 
     * @type {Array<PaymentReturnModel>}
     * @memberof BasketReturnModel
     */
    readonly payments?: Array<PaymentReturnModel>;
    /**
     * 
     * @type {Array<ShipmentReturnModel>}
     * @memberof BasketReturnModel
     */
    readonly shipments?: Array<ShipmentReturnModel>;
}

/**
 * Check if a given object implements the BasketReturnModel interface.
 */
export function instanceOfBasketReturnModel(value: object): boolean {
    return true;
}

export function BasketReturnModelFromJSON(json: any): BasketReturnModel {
    return BasketReturnModelFromJSONTyped(json, false);
}

export function BasketReturnModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): BasketReturnModel {
    if (json == null) {
        return json;
    }
    return {
        
        'basketId': json['basketId'] == null ? undefined : json['basketId'],
        'marketId': json['marketId'] == null ? undefined : json['marketId'],
        'lines': json['lines'] == null ? undefined : ((json['lines'] as Array<any>).map(LineItemReturnModelFromJSON)),
        'billingAddress': json['billingAddress'] == null ? undefined : AddressFromJSON(json['billingAddress']),
        'shippingAddress': json['shippingAddress'] == null ? undefined : AddressFromJSON(json['shippingAddress']),
        'useBillingAddressForShipping': json['useBillingAddressForShipping'] == null ? undefined : json['useBillingAddressForShipping'],
        'note': json['note'] == null ? undefined : json['note'],
        'acceptNewsletter': json['acceptNewsletter'] == null ? undefined : json['acceptNewsletter'],
        'acceptTerms': json['acceptTerms'] == null ? undefined : json['acceptTerms'],
        'subtotal': json['subtotal'] == null ? undefined : MoneyFromJSON(json['subtotal']),
        'total': json['total'] == null ? undefined : MoneyFromJSON(json['total']),
        'shippingTotal': json['shippingTotal'] == null ? undefined : MoneyFromJSON(json['shippingTotal']),
        'totalVat': json['totalVat'] == null ? undefined : MoneyFromJSON(json['totalVat']),
        'shippingVat': json['shippingVat'] == null ? undefined : MoneyFromJSON(json['shippingVat']),
        'totalDiscount': json['totalDiscount'] == null ? undefined : MoneyFromJSON(json['totalDiscount']),
        'remainingTotal': json['remainingTotal'] == null ? undefined : MoneyFromJSON(json['remainingTotal']),
        'paidTotal': json['paidTotal'] == null ? undefined : MoneyFromJSON(json['paidTotal']),
        'estimatedShippingCost': json['estimatedShippingCost'] == null ? undefined : MoneyFromJSON(json['estimatedShippingCost']),
        'currency': json['currency'] == null ? undefined : json['currency'],
        'quantity': json['quantity'] == null ? undefined : json['quantity'],
        'paymentTerms': json['paymentTerms'] == null ? undefined : PaymentTermsFromJSON(json['paymentTerms']),
        'promoCodes': json['promoCodes'] == null ? undefined : json['promoCodes'],
        'created': json['created'] == null ? undefined : (new Date(json['created'])),
        'updated': json['updated'] == null ? undefined : (new Date(json['updated'])),
        'orderState': json['orderState'] == null ? undefined : json['orderState'],
        'payments': json['payments'] == null ? undefined : ((json['payments'] as Array<any>).map(PaymentReturnModelFromJSON)),
        'shipments': json['shipments'] == null ? undefined : ((json['shipments'] as Array<any>).map(ShipmentReturnModelFromJSON)),
    };
}

export function BasketReturnModelToJSON(value?: Omit<BasketReturnModel, 'useBillingAddressForShipping'|'note'|'acceptNewsletter'|'acceptTerms'|'quantity'|'promoCodes'|'created'|'updated'|'payments'|'shipments'> | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'basketId': value['basketId'],
        'marketId': value['marketId'],
        'lines': value['lines'] == null ? undefined : ((value['lines'] as Array<any>).map(LineItemReturnModelToJSON)),
        'billingAddress': AddressToJSON(value['billingAddress']),
        'shippingAddress': AddressToJSON(value['shippingAddress']),
        'subtotal': MoneyToJSON(value['subtotal']),
        'total': MoneyToJSON(value['total']),
        'shippingTotal': MoneyToJSON(value['shippingTotal']),
        'totalVat': MoneyToJSON(value['totalVat']),
        'shippingVat': MoneyToJSON(value['shippingVat']),
        'totalDiscount': MoneyToJSON(value['totalDiscount']),
        'remainingTotal': MoneyToJSON(value['remainingTotal']),
        'paidTotal': MoneyToJSON(value['paidTotal']),
        'estimatedShippingCost': MoneyToJSON(value['estimatedShippingCost']),
        'currency': value['currency'],
        'paymentTerms': PaymentTermsToJSON(value['paymentTerms']),
        'orderState': value['orderState'],
    };
}

